import React from 'react'
import clsx from 'clsx'

import CheckboxAtom from '../../../../components/atoms/Checkbox'

import useStyles from './styles'

export interface CheckboxProps {
  checked?: boolean
  disabled?: boolean
  onCheck?: Function
  children?: React.ReactNode
  className?: string
  defaultClass?: string
  variant?: string
  onMouseEnter?: CallableFunction
  onMouseLeave?: CallableFunction
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  disabled,
  onCheck,
  children,
  className,
  defaultClass,
  variant,
  onMouseEnter,
  onMouseLeave
}) => {
  const articleVariant = variant && variant === 'articleTable'
  const classes = useStyles({ disabled, articleVariant })

  const handleOnMouseEnter = React.useCallback(() => {
    if (onMouseEnter) {
      onMouseEnter()
    }
  }, [onMouseEnter])

  const handleOnMouseLeave = React.useCallback(() => {
    if (onMouseLeave) {
      onMouseLeave()
    }
  }, [onMouseLeave])

  return (
    <div
      className={clsx(classes.root, className, variant && classes[variant])}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      <CheckboxAtom
        checked={checked}
        disabled={disabled}
        onChange={e => {
          e.stopPropagation()
          onCheck && onCheck(e.target.checked)
        }}
        className={classes.checkbox}
        icon={
          articleVariant && (
            <svg
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.5 11H7.5C10 11 11 10 11 7.5V4.5C11 2 10 1 7.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11Z'
                stroke='#B64FCD'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          )
        }
        checkedIcon={
          articleVariant && (
            <svg
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M9.5 1H2.5C1.67285 1 1 1.67285 1 2.5V9.5C1 10.3272 1.67285 11 2.5 11H9.5C10.3272 11 11 10.3272 11 9.5V2.5C11 1.67285 10.3272 1 9.5 1Z'
                fill='#B64FCD'
              />
              <path
                d='M5.37499 7.74998C5.24706 7.74998 5.11913 7.70115 5.02148 7.60349L3.77148 6.3535C3.57617 6.15819 3.57617 5.84179 3.77148 5.64648C3.9668 5.45116 4.2832 5.45116 4.47851 5.64648L5.37499 6.54295L7.52147 4.39648C7.71678 4.20117 8.03318 4.20117 8.22849 4.39648C8.4238 4.59179 8.4238 4.9082 8.22849 5.10351L5.72851 7.60349C5.63085 7.70115 5.50292 7.74998 5.37499 7.74998Z'
                fill='white'
              />
            </svg>
          )
        }
      />

      <div
        onClick={() => !disabled && onCheck && onCheck(!checked)}
        className={clsx(!disabled && classes.text, disabled && defaultClass)}
      >
        {children}
      </div>
    </div>
  )
}

export default Checkbox
